import './Article.scss';
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';

export interface Article {
  title: string;
  body: { value: string }
}

interface ArticleProps {
  article: Article;
}

export default function Article({ article }: ArticleProps) {

  return (
    <div className={'article-container'}>
      {parse(DOMPurify.sanitize(article.body?.value))}
    </div>
  );

}